module.exports = __webpack_public_path__ + "static/mobileback-8e3097e4e1200d5e099c9ee10fdddcec.png";